import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faClock,
  faComment,
  faEye,
  faHourglassStart,
  faInfoCircle,
  faPlay,
  faSearch,
  faStar,
  faThumbsUp,
  faUser,
  faFilter,
  faCalendar,
  faAddressCard,
  faLock,
  faEnvelopeOpenText,
  faEnvelope,
  faInbox,
  faExternalLinkAlt,
  faPhone,
  faCity,
  faGlobe,
  faMapMarked,
  faBirthdayCake,
  faPlayCircle,
  faTimes,
  faArrowLeft,
  faTicketAlt,
} from '@fortawesome/free-solid-svg-icons';

import {
  //fab,
  faTwitter,
  faFacebook,
  //faLinkedin,
  //faGithub,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faSearch,
  faUser,
  faThumbsUp,
  faPlay,
  faEye,
  faComment,
  faStar,
  faClock,
  faInfoCircle,
  faHourglassStart,
  faEye,
  faClock,
  faFilter,
  faCalendar,
  faTwitter,
  faFacebook,
  faInstagram,
  faAddressCard,
  faLock,
  faEnvelope,
  faEnvelopeOpenText,
  faUser,
  faInbox,
  faExternalLinkAlt,
  faPhone,
  faCity,
  faGlobe,
  faMapMarked,
  faBirthdayCake,
  faPlayCircle,
  faTimes,
  faArrowLeft,
  faTicketAlt
);
